module.exports = __webpack_public_path__ + "assets/youlechangsuo.3af59b0b.svg";